<div class="sector-selector">
	<input
		type="text"
		autofocus
		(input)="onSearchChange($event)"
		class="filter"
		placeholder="{{ placeholder }}"
	/>
	@for(sectorAndCount of filteredData; track
	`${sectorAndCount.parentSector}${sectorAndCount.sectorOrOption}`) {
	<label class="item-info">
		<div
			class="item-name-and-company-count"
			[ngClass]="{ 'is-sub-sector': !!sectorAndCount.parentSector }"
			(click)="handleLabelClick(sectorAndCount, $event)"
		>
			<div class="item-name-expander-and-company-name">
				@if(isExpandable(sectorAndCount) ){
				<button
					class="child-toggle"
					[ngClass]="{
							open: openChildOptions[sectorAndCount.sectorOrOption],
						}"
				></button
				>}
				<div class="item-name selected-text-color">
					{{ sectorAndCount.sectorOrOption }}
				</div>
			</div>
			@if(includeCounts){
			<div
				class="company-count"
				[ngClass]="{ 'for-sectors': !sectorAndCount.parentSector }"
			>
				{{
					LocPluralize(
						LocalizedTextIds.CompanyCount,
						sectorAndCount.count,
						sectorAndCount.count
					)
				}}
			</div>
			}
		</div>
		@if(sectorAndCount.parentSector || selectableSectors) {
		<div class="select-checkbox">
			<input
				type="checkbox"
				class="checkbox"
				[ngClass]="{ indeterminate: isInderminate(sectorAndCount) }"
				[checked]="isSelected(sectorAndCount)"
				(click)="updateSelection(sectorAndCount, $event)"
			/>
		</div>
		}
	</label>
	}
</div>
